import { Button } from "components/DesignSystem/Button/Button";
import { ReviewSparkle } from "components/icons/ReviewSparkle";
import {
  CLICKED_CONFIRM_FIELD_ON_RECORDS_AND_SETUP,
  CLICKED_FINISH_REVIEW_ON_RECORDS_AND_SETUP,
  CLICKED_REJECT_FIELD_ON_RECORDS_AND_SETUP,
  CLICKED_REVIEW_AND_CONFIRM_ON_RECORDS_AND_SETUP,
} from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useState } from "react";
import { useGetExtractionReviewQuery } from "v2/store/entityDocumentsApi";
import { hasUnsavedReview } from "v2/utils/countReviewFields";
import { ReviewExtractedInfoModal } from "./ReviewExtractedInfoModal";

type ExtractedReviewBannerProps = {
  entityId: string;
};

export const ExtractedReviewBanner = ({
  entityId,
}: ExtractedReviewBannerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: review } = useGetExtractionReviewQuery({ entityId });
  const { trackEvent } = useAnalytics();

  const handleReviewAndConfirm = (): void => {
    trackEvent(CLICKED_REVIEW_AND_CONFIRM_ON_RECORDS_AND_SETUP);
    setIsOpen(true);
  };

  const handleConfirmField = (): void =>
    trackEvent(CLICKED_CONFIRM_FIELD_ON_RECORDS_AND_SETUP);

  const handleRejectField = (): void =>
    trackEvent(CLICKED_REJECT_FIELD_ON_RECORDS_AND_SETUP);

  const handleFinishReviewClick = (): void =>
    trackEvent(CLICKED_FINISH_REVIEW_ON_RECORDS_AND_SETUP);

  const showBanner = hasUnsavedReview(review);
  if (!showBanner && !isOpen) {
    return null;
  }

  return (
    <>
      {showBanner && (
        <div className="extracted-review-banner t-flex t-items-center t-justify-between t-gap-10 t-rounded-xl t-border t-border-solid t-px-6 t-py-4 sm:t-flex-col sm:t-items-start sm:t-gap-3 sm:t-px-4">
          <div className="t-flex t-flex-col t-gap-0.5">
            <div className="t-flex t-items-center t-gap-2 t-text-subtext t-text-text-60">
              <ReviewSparkle className="t-h-4 t-w-4 t-shrink-0" />
              Review and confirm extracted information
            </div>
            <p className="t-m-0 t-text-body t-text-neutral-50">
              We have extracted information from the documents you uploaded.
              Review each field and confirm it&apos;s correct before updating
              your records.
            </p>
          </div>
          <Button
            customType="primary"
            size="small"
            onClick={handleReviewAndConfirm}
          >
            Review &amp; confirm
          </Button>
        </div>
      )}
      <ReviewExtractedInfoModal
        entityId={entityId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirmField={handleConfirmField}
        onRejectField={handleRejectField}
        onFinishReviewClick={handleFinishReviewClick}
      />
    </>
  );
};
